<template>
    <div class="headerRoot">
        <el-row>
            <el-col :lg="24" :xl="24" class=" hidden-xs-only">
                <div class="header" >
                    <router-link class="headerLogo"  :to="{ path: '/Authors' }">
                        <img  :src="imgObj.paperLogo" style="width: 100%;height: 100%;" alt="">
                    </router-link>
                    <router-link class="headerLeft" :to="{ path: '/Authors' }">
                        <div class="mainTitle">{{ $t('headerModule.mainTitle')}}</div>
                        <div class="subTitle">{{$t('headerModule.subTitle')}}</div>
                    </router-link>
                    <div class="headerRight">
                        <ul class="navList" v-if="!isLogin">
                            <li  v-for="(item, index) in $t('headerModule.navListNew')" :key="index">
                                <router-link  v-if="item.path && item.path!='/loginOut'"  :class="[item.className]" :style="{color: currentPath=='/'&&item.path=='/Authors'?'#FEAE00':currentPath==item.path&&item.colorJudg&&item.path=='/journalsAndPublishers'?'#BB86FC':currentPath==item.path&&item.colorJudg?'#FEAE00':''}"   :to="{ path:item.path }" > {{ item.name }}</router-link>
                                <span @click="goToPage(item.path,item.id)" v-else :class="[item.className]" > {{ item.name }}</span>
                            </li>
                        </ul>
                        <ul class="navList" v-else>
                            <li  v-for="(item, index) in $t('headerModule.navListLog')" :key="index" style="cursor: pointer;">
                            <!-- <span v-if="item.name !=='lang'"> {{index==0?username: item.name }}</span> -->
                                <router-link  v-if="item.path && item.name =='email'"  :class="[item.className]"   :to="{ path:item.path }" > {{username?username: item.name }}</router-link>
                                <router-link  v-else-if="item.path && item.path!='/loginOut'"  :class="[item.className]" :style="{color:currentPath=='/'&&item.path=='/Authors'?'#FEAE00':currentPath==item.path&&item.colorJudg&&item.path=='/journalsAndPublishers'?'#BB86FC':currentPath==item.path&&item.colorJudg?'#FEAE00':''}"   :to="{ path:item.path }" > {{ item.name }}</router-link>
                                <span @click="goToPage(item.path,item.id)" v-else :class="[item.className]" > {{ item.name }}</span>
                                <!-- <span @click="goToPage(item.path,item.id)"   v-else :style="{color:currentPath==item.path&&item.colorJudg?'#FEAE00':''}" :class="[item.className]" > {{item.name }}</span> -->
                            <!-- <div v-else>
                                <img v-if="currentlang=='zh'"  :src="imgObj.langActBtn"  style="cursor: pointer; width:32px ;height: 32px;" alt="" @click="changelang('en')">
                                <img v-else  :src="imgObj.langBtn"  style="cursor: pointer; width:32px ;height: 32px;" alt="" @click="changelang('zh')">
                            </div> -->
                            </li>
                        </ul>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="24" :xl="24" class=" hidden-sm-and-up">
                <div class="header" >
                    <div class="headerLeft" @click="gotoHome">
                        <img :src="imgObj.paperLogo" style="width: 8vw;height: 8vw;" alt="">
                    </div>
                    <div class="headerRight"  style="display:flex;gap:3vw" v-if="!isLogin">
                        <ul class="navList">
                            <li @click="goToPage(item.path,item.id)" :class="[item.className]" v-for="(item, index) in $t('headerModule.navList1')" :key="index">
                            <span > {{ item.name }}</span>
                            </li>
                        </ul>
                         <div class="menubtn" :style="{color:drawerLoginShow?'#fff':'#FEAE00',background:drawerLoginShow?'#FEAE00':'',padding:'0 2vw'} " @click="drawerLoginShow=!drawerLoginShow">
                             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="menu" class="lucide lucide-menu w-7 h-7"><path d="M4 12h16"></path><path d="M4 18h16"></path><path d="M4 6h16"></path></svg>
                        </div>
                    </div>
                    <div class="headerRight" v-else style="display: flex;gap: 3vw;align-items: center;">
                        <ul class="navList" >
                            <li @click="goToPage(item.path,item.id)" :class="[item.className]" v-for="(item, index) in $t('headerModule.navListLog1')" :key="index" style="cursor: pointer;">
                            <span v-if="item.name !=='lang'"> {{index==0?username: item.name }}</span>
                            </li>
                        </ul>
                        <div class="menubtn" :style="{color:drawerShow?'#fff':'#FEAE00',background:drawerShow?'#FEAE00':''} " @click="drawerShow=!drawerShow">
                            <!-- <img :src="imgObj.menuIcon" style=" width: 7vw; height: 7vw;" alt=""> -->
                            <span>Menu</span>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>

  <el-drawer
            title="我是标题"
            direction="ttb"
            :modal="false"
            :visible.sync="drawerLoginShow"
            :with-header="false">
            <div class="drawerBox">
                <div class="stepItem" v-for="(item,index) in drawLoginObj" :key="index">
                    <div @click="goToPage(item.path,item.id)"  class="titleItem" :style="{color:currentPath=='/'&&item.path=='/Authors'?'#FEAE00': currentPath==item.path&&item.colorJudg&&item.path=='/journalsAndPublishers'?'#BB86FC':currentPath==item.path&&item.colorJudg?'#FEAE00':'',fontWeight: 400}" style="font-weight: 400">{{ item.name}}</div>
                </div>

            </div>
        </el-drawer>

        <el-drawer
            title="我是标题"
            direction="ttb"
            :modal="false"
            :visible.sync="drawerShow"
            :with-header="false">
            <div class="drawerBox">
                <div class="stepItem" v-for="(item,index) in drawerObj" :key="index">
                    <div class="titleItem">{{ item.mainTitle}}</div>
                    <div v-if="item.mainTitle=='Tools'">
                        <div  @click="gotoNeLink(arr.link)" :style="{background: arr.path==currentPath?'rgba(0, 0, 0, 0.05)':''}" class="itemBox" v-for="(arr, num) in item.subTitle" :key="num">
                            <div class="columItem">{{ arr.name }}</div>
                        </div>
                    </div>
                    <div v-else>
                    <div @click="goToPage(arr.path)"  :style="{background: arr.path==currentPath?'rgba(0, 0, 0, 0.05)':''}" class="itemBox" v-for="(arr, num) in item.subTitle" :key="num">
                        <div v-if="index>0 && index<3">
                            <div  v-if="pathStatus[arr.index]" :style="{ display: 'flex',alignItems: 'center',}">
                                <svg xmlns="http://www.w3.org/2000/svg" width="3.6vw" height="3.6vw" viewBox="0 0 24 24" fill="none">
                                    <path d="M3 19.5C3 20.3284 3.67157 21 4.5 21L19.5 21C20.3284 21 21 20.3284 21 19.5L21 4.5C21 3.67158 20.3284 3 19.5 3H4.5C3.67158 3 3 3.67157 3 4.5V19.5ZM10.5 14.0356L16.1623 8.37344L17.2229 9.43411L10.5 16.1569L6.77014 12.4274L7.83075 11.3667L10.5 14.0356Z" fill="#FEAE00"/>
                                </svg>
                            </div>
                            <div v-else :style="{ display: 'flex',alignItems: 'center',}">
                                <svg xmlns="http://www.w3.org/2000/svg" width="3.6vw" height="3.6vw" viewBox="0 0 24 24" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 21C3.67157 21 3 20.3284 3 19.5V4.5C3 3.67157 3.67158 3 4.5 3H19.5C20.3284 3 21 3.67158 21 4.5L21 19.5C21 20.3284 20.3284 21 19.5 21L4.5 21ZM4.5 19.5L4.5 4.5L19.5 4.5L19.5 19.5L4.5 19.5Z" fill="black" fill-opacity="0.9"/>
                                </svg>
                            </div>
                        </div>
                        <div class="columItem">{{ arr.name }}</div>
                    </div>
                    </div>
                </div>
                <div class="stepItem">
                    <div  @click="goToPage('/loginOut')"  class="itemBox">
                        <div style="color:#dd2c00" class="columItem">Logout</div>
                    </div>
                </div>

            </div>
        </el-drawer>
    </div> 
</template>
<script>
import debounce from 'lodash/debounce';
import i18n from '../../i8n';
import { nextTick } from 'vue';
import { color } from 'd3';
const Base64 = require('js-base64').Base64

  export default {
    props: {
        necessaryObj: {
            type: Object,
        },
        indexChange:{
            type:String
        }
    },
    data() {
      return {
        currentlang:'zh',
        imgObj:{
            mainLogo:require("../../assets/img/main/mainLogo.png"),
            mainLeft:require("../../assets/img/main/mainLeft.png"),
            material1:require("../../assets/img/main/material1.png"),
            material2:require("../../assets/img/main/material2.png"),
            material3:require("../../assets/img/main/material3.png"),
            material4:require("../../assets/img/main/material4.png"),
            material5:require("../../assets/img/main/material5.png"),
            girl:require("../../assets/img/main/girl.png"),
            man:require("../../assets/img/main/man.png"),
            thirdImg:require("../../assets/img/main/thirdImg.png"),
            langBtn:require("../../assets/img/main/langBtn.png"),
            langActBtn:require("../../assets/img/main/langActBtn.png"),
            paperLogo:require("../../assets/img/main/paperLogo.png"),
            menuIcon:require("../../assets/img/main/menuIcon.png"),
        },
        drawerShow:false,
        // navList:[
        //     {name:'Home',className:'navItem',path:'/Authors'},
        //     {name:'Fee Schedule',className:'navItem',path:''},
        //     {name:'Contact Us',className:'navItem',path:''},
        //     {name:'FAQ',className:'navItem',path:''},
        //     {name:'Log in',className:'navBottomLogin',path:'/information'},
        //     {name:'Register',className:'navBottomReg',path:'/information'},
        // ],
        payment:[],
        paymentEn:[],
        subscription:[],
        subscriptionEn:[],
        isLogin :false,
        username: '',
        drawerLoginShow:false,
        drawLoginObj:[],
        drawerObj:[],
        currentPath:'',
        pathStatus:{},
      }
    },
    watch:{
        necessaryObj:{
            handler(newVal, oldVal){
                console.log('change',newVal)
                this.pathStatus={...newVal}
                // this.statusArr[1].icon = newVal.scholar
                // this.statusArr[2].icon = newVal.strategy 
                // this.statusArr[3].icon = newVal.article 
                // this.statusArr[4].icon = newVal.userPackage
                // this.currentStatus =  newVal.status
            },
            deep:true
        },
        indexChange:{
            handler(newVal, oldVal){
                console.log('99999,indexChange',newVal,this.currentPath)
                this.currentPath = newVal.split('-')[0]
            },
            deep:true
        },
        
    },
    methods: {
         //获取可选套餐列表
        getPackageList(){
            this.$httpsGET('getPayPackage',{}).then(res => {
                if(res.code===0){
                    console.log(12233456777,res)
                    let detail = res.data.payment[0].details
                    let detailEn = res.data.payment[0].detailsEn
                    this.payment = []
                    this.paymentEn = []
                    this.payment.push({title:'test',subTitle:'test',amount:'3',monthTotalAmount:'$3',monthAmount:'',discounts:'3',numOfPeople:detail[0].key,analysis:detail[1].key,relevance:detail[2].key,anonymous:detail[3].key,exposure:detail[4].key,push:detail[5].key,open:detail[6].key})
                    this.paymentEn.push({title:'test',subTitle:'test',amount:'3',monthTotalAmount:'$3',monthAmount:'',discounts:'3',numOfPeople:detailEn[0].key,analysis:detailEn[1].key,relevance:detailEn[2].key,anonymous:detailEn[3].key,exposure:detailEn[4].key,push:detailEn[5].key,open:detailEn[6].key})
                     this.paymentOfYear = []
                    this.paymentOfYearEn = []
                    this.paymentOfYear.push({title:'test',subTitle:'test',amount:'3',monthTotalAmount:'$3',monthAmount:'',discounts:'3',numOfPeople:detail[0].key,analysis:detail[1].key,relevance:detail[2].key,anonymous:detail[3].key,exposure:detail[4].key,push:detail[5].key,open:detail[6].key})
                    this.paymentOfYearEn.push({title:'test',subTitle:'test',amount:'3',monthTotalAmount:'$3',monthAmount:'',discounts:'3',numOfPeople:detailEn[0].key,analysis:detailEn[1].key,relevance:detailEn[2].key,anonymous:detailEn[3].key,exposure:detailEn[4].key,push:detailEn[5].key,open:detailEn[6].key})
                    this.subscription = []
                    this.subscriptionEn = []
                    this.subscription.push({title:'test',subTitle:'test',amount:'3',monthTotalAmount:'$3',monthAmount:'',discounts:'3',numOfPeople:detail[0].key,analysis:detail[1].key,relevance:detail[2].key,anonymous:detail[3].key,exposure:detail[4].key,push:detail[5].key,open:detail[6].key})
                    this.subscriptionEn.push({title:'test',subTitle:'test',amount:'3',monthTotalAmount:'$3',monthAmount:'',discounts:'3',numOfPeople:detailEn[0].key,analysis:detailEn[1].key,relevance:detailEn[2].key,anonymous:detailEn[3].key,exposure:detailEn[4].key,push:detailEn[5].key,open:detailEn[6].key})
                    let payObj = res.data.payment
                    let subObj = res.data.subscription
                    for(let i in payObj){
                        // day为1的是一年，day为30的是一月
                        if(payObj[i].day==30){
                            let totalAmount = payObj[i].amount/100
                            let amount = (totalAmount/payObj[i].peopleNum).toFixed(2)
                            this.payment.push({link:payObj[i].paymentLink,title:payObj[i].packageName,subTitle:payObj[i].descTxt,amount:amount,monthTotalAmount:totalAmount,monthAmount:totalAmount,discounts:'',numOfPeople:payObj[i].details[0].value,analysis:payObj[i].details[1].value,relevance:payObj[i].details[2].value,anonymous:payObj[i].details[3].value,exposure:payObj[i].details[4].value,push:payObj[i].details[5].value,open:payObj[i].details[6].value})
                            this.paymentEn.push({link:payObj[i].paymentLink,title:payObj[i].packageNameEn,subTitle:payObj[i].descTxtEn,amount:amount,monthTotalAmount:totalAmount,monthAmount:totalAmount,discounts:'',numOfPeople:payObj[i].detailsEn[0].value,analysis:payObj[i].detailsEn[1].value,relevance:payObj[i].detailsEn[2].value,anonymous:payObj[i].detailsEn[3].value,exposure:payObj[i].detailsEn[4].value,push:payObj[i].detailsEn[5].value,open:payObj[i].detailsEn[6].value})
                        }else{
                            let totalAmount = payObj[i].amount/100
                            let amount = (totalAmount/payObj[i].peopleNum).toFixed(2)
                            this.paymentOfYear.push({link:payObj[i].paymentLink,title:payObj[i].packageName,subTitle:payObj[i].descTxt,amount:amount,monthTotalAmount:totalAmount,monthAmount:totalAmount,discounts:'',numOfPeople:payObj[i].details[0].value,analysis:payObj[i].details[1].value,relevance:payObj[i].details[2].value,anonymous:payObj[i].details[3].value,exposure:payObj[i].details[4].value,push:payObj[i].details[5].value,open:payObj[i].details[6].value})
                            this.paymentOfYearEn.push({link:payObj[i].paymentLink,title:payObj[i].packageNameEn,subTitle:payObj[i].descTxtEn,amount:amount,monthTotalAmount:totalAmount,monthAmount:totalAmount,discounts:'',numOfPeople:payObj[i].detailsEn[0].value,analysis:payObj[i].detailsEn[1].value,relevance:payObj[i].detailsEn[2].value,anonymous:payObj[i].detailsEn[3].value,exposure:payObj[i].detailsEn[4].value,push:payObj[i].detailsEn[5].value,open:payObj[i].detailsEn[6].value})
                        
                        }
                   }
                    for(let i in subObj){
                        let totalAmount = subObj[i].amount/100
                        let amount = (totalAmount/subObj[i].peopleNum).toFixed(2)
                        this.subscription.push({link:subObj[i].paymentLink,title:subObj[i].packageName,subTitle:subObj[i].descTxt,amount:amount,monthTotalAmount:totalAmount,monthAmount:totalAmount,discounts:'',numOfPeople:subObj[i].details[0].value,analysis:subObj[i].details[1].value,relevance:subObj[i].details[2].value,anonymous:subObj[i].details[3].value,exposure:subObj[i].details[4].value,push:subObj[i].details[5].value,open:subObj[i].details[6].value})
                        this.subscriptionEn.push({link:subObj[i].paymentLink,title:subObj[i].packageNameEn,subTitle:subObj[i].descTxtEn,amount:amount,monthTotalAmount:totalAmount,monthAmount:totalAmount,discounts:'',numOfPeople:subObj[i].detailsEn[0].value,analysis:subObj[i].detailsEn[1].value,relevance:subObj[i].detailsEn[2].value,anonymous:subObj[i].detailsEn[3].value,exposure:subObj[i].detailsEn[4].value,push:subObj[i].detailsEn[5].value,open:subObj[i].detailsEn[6].value})
                    }
                    console.log(463333366,this.subscriptionEn)
                    console.log(this.paymentEn)
                    i18n.mergeLocaleMessage('zh', { tableModule: { packageObj2:[...this.payment] } });
                    i18n.mergeLocaleMessage('zh', { tableModule: { packageObj3:[...this.paymentOfYear] } });
                    i18n.mergeLocaleMessage('zh', { tableModule: { packageObj:[...this.subscription] } });
                    i18n.mergeLocaleMessage('en', { tableModule: { packageObj2:[...this.paymentEn] } });
                    i18n.mergeLocaleMessage('en', { tableModule: { packageObj3:[...this.paymentOfYearEn] } });
                    i18n.mergeLocaleMessage('en', { tableModule: { packageObj:[...this.subscriptionEn] } });
                    
                    
                }
            })
        },
        changelang(val){
            console.log(3333)
            this.currentlang = val
            localStorage.setItem('lang',val) 
            this.$i18n.locale = val;
            console.log(val)
        },
        gotoHome(){
            if(this.$route.path !== '/Authors'){
                // this.$router.replace('/Authors')
                this.$router.push({path:'/Authors'})
            }
        },
        gotoNeLink(link){
                window.open(link, '_blank');
            },
        goToPage(path,elementId){
            console.log(path)
            console.log(elementId)
            this.drawerLoginShow = false
            if(path){
                this.drawerShow = false
                console.log( this.$route.path)
                if(this.$route.path !==path){
                    if(path=='/loginOut'){
                        this.$https('userlogout',{}).then(res => {
                            if(res.code===0){
                                console.log(res)
                                this.$message.success(res.dataEn);
                                localStorage.removeItem('thesis-token');
                                localStorage.removeItem('userInfo');
                                // localStorage.clear()
                                this.$router.push({path:'/login'})
                            }
                        })
                    }else{
                        this.$router.push({path:path})
                        this.currentPath = path
                    } 
                }
                // 使用路由名称或路径来跳转
                // this.$router.push({ name: 'PageName' }); // 如果使用了命名路由
                // 或者
            }
            if(elementId){
                if(this.$route.path =='/Authors'){
                    console.log(333)
                    let width = window.innerWidth;
                    if(width>=1200){
                        this.$emit('handleIdChange',elementId)

                    }else if(width<767 && elementId =='pricing'){
                        let id = elementId +'Mobile'
                        this.$emit('handleIdChange',id)
                    }else{
                        let id = elementId +'Ipad'
                        this.$emit('handleIdChange',id)
                    }
                }else{
                    let id = elementId
                    let width = window.innerWidth;
                    
                    if(width<767 && id =='pricing'){
                        id = elementId +'Mobile'
                    }else if(width<1200){
                        id = elementId +'Ipad'
                    }
                    console.log(id,3333)
                    // return
                    this.$router.push({
                        path: '/Authors',
                        query: {
                            anchor: id
                        }});
                }
            }
        }
   
    },
    mounted: function() {
        this.pathStatus={...this.necessaryObj}
        console.log(3444, this.pathStatus)
        this.currentPath = this.$route.path 
        console.log(222,this.currentPath )
        console.log(this.$t('navigate.flowObj0'))
        this.drawLoginObj=[]
         this.drawLoginObj= this.$t('headerModule.navListOfPhone').slice(0,-2)
        console.log(7777, this.drawLoginObj)
        this.drawerObj[0]={
            mainTitle:this.$t('navigate.flowObj1')[0].mainTitle,
            subTitle:this.$t('navigate.flowObj1')[0].subTitle
        }
        this.drawerObj[1]={
            mainTitle:this.$t('navigate.flowObj1')[1].mainTitle,
            subTitle:this.$t('navigate.flowObj1')[1].subTitle
        }
        this.drawerObj[2]={
            mainTitle:this.$t('navigate.flowObj1')[2].mainTitle,
            subTitle:this.$t('navigate.flowObj1')[2].subTitle
        } 
        //  this.drawerObj[3]={
        //     mainTitle:this.$t('navigate.flowObj1')[2].mainTitle,
        //     subTitle:this.$t('navigate.flowObj1')[2].subTitle
        // } 
        // this.drawerObj[3]={
        //     mainTitle:this.$t('navigate.flowObj2')[0].mainTitle,
        //     subTitle:this.$t('navigate.flowObj2')[0].subTitle
        // }
        if (this.currentPath !== '/login' && this.currentPath !== '/register' && this.currentPath !='/resetPassword') {
            setTimeout(() => {
                this.getPackageList()
                
            }, 2000);
        }

        
        console.log(666,this.drawerObj)
        const localUser = localStorage.getItem('thesis-token');
        let token = ''
        if(localUser){
            const localToken = Base64.decode(localUser).split('----');
            token = localToken[1].replace(/\d{4}$/, '');
           
        }
        if (token) {
            this.isLogin = true
            this.username = localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo')).userName
            
            if(this.$route.path == '/login' ||this.$route.path =='/register' || this.$route.path =='/resetPassword'  ){
                this.$router.push({path:'/Authors'})
            }
            
        }else{
            this.isLogin = false
            this.username = ''
        }
    },
    activated() {
        
    }
  }
</script>
<style> 
    .el-message{
        min-width: 120px !important;
        z-index: 999999 !important;
    }
    .el-message * {
        color: var(---, #FAFAFA) !important;
    }
    
    .el-icon-success  {
        color: #FAFAFA !important; /* 更改为您想要的颜色 */
    }
    .el-icon-error  {
        color: #D54941 !important; /* 更改为您想要的颜色 */
    }
    .el-icon-info  {
        color: #FAFAFA !important; /* 更改为您想要的颜色 */
    }
    .el-icon-warning  {
        color: #FAFAFA !important; /* 更改为您想要的颜色 */
    }
    .el-message--success{
            border-radius: 6px;
            border: none !important;
            background: rgba(0, 0, 0, 0.70) !important;
            /* Shadow/Shadow-3 上层投影 */
            box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.05), 0px 16px 24px 2px rgba(0, 0, 0, 0.04), 0px 8px 10px -5px rgba(0, 0, 0, 0.08);
    }
    .el-message--warning{
            border-radius: 6px;
            border: none !important;
            background:  rgba(0, 0, 0, 0.70) !important;

            /* Shadow/Shadow-3 上层投影 */
            box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.05), 0px 16px 24px 2px rgba(0, 0, 0, 0.04), 0px 8px 10px -5px rgba(0, 0, 0, 0.08);
    }
    .el-message--info {
        border-radius: 6px;
        border: none !important;
        background: rgba(0, 0, 0, 0.70) !important;

        /* Shadow/Shadow-3 上层投影 */
        box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.05), 0px 16px 24px 2px rgba(0, 0, 0, 0.04), 0px 8px 10px -5px rgba(0, 0, 0, 0.08);
    }
    
    .el-message--error {
        border-radius: 6px;
        border: none !important;
        background:rgba(0, 0, 0, 0.70) !important;

        /* Shadow/Shadow-3 上层投影 */
        box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.05), 0px 16px 24px 2px rgba(0, 0, 0, 0.04), 0px 8px 10px -5px rgba(0, 0, 0, 0.08);
    }
</style>

<style  lang="scss" >
.headerRoot{
    .header{
        background:  rgb(250 250 250 / 80%);
        /* 渐变效果：从透明到白色 */
        background: linear-gradient(
            to bottom,
            rgba(250, 250, 250, 0.9) 0%,
            rgba(250, 250, 250, 0.8) 40%,
            rgba(250, 250, 250, 0.6) 100%
        );
        backdrop-filter: blur(10px); /* 关键：磨砂效果 */
        -webkit-backdrop-filter: blur(10px); /* Safari 支持 */
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);
        display: flex;
        width: 100%;
        padding: 24px 36px;
        justify-content: center;
        align-items: center;
        gap: 32px;
        .headerLogo{
            width: 58px;
            height: 58px;
            display: flex;
            margin-right: -26px;
            cursor: pointer;
        }
        .headerLeft{
            cursor: pointer;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            gap: var(--8, 8px);
            flex: 1 0 0;
            .mainTitle{
                font-family: Times New Roman !important;
                color: #212121;
                font-size: 28px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }
            .subTitle{
                font-family: Times New Roman !important;
                color: #757575;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
        }
        .headerRight{
            .navList{
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 24px;
                list-style: none;
                margin: 0;
                padding: 0;
                .noticeBox{
                    // position: relative;
                    // left: -30px;
                    .noticeNum{
                        // position: absolute;
                        top: 0;
                        right: -1px;
                        transform: translateY(-50%) translateX(-10%);
                        background-color: red;
                        border-radius: 10px;
                        color: #fff;
                        display: inline-block;
                        font-size: 12px;
                        height: 18px;
                        line-height: 18px;
                        padding: 0 6px;
                        text-align: center;
                        white-space: nowrap;
                        border: 1px solid #fff;
                    }
                }
                .navItem{
                    color:  #212121;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 24px; /* 150% */
                    // text-transform: capitalize;
                    cursor: pointer;
                }
                .navBottomLogin{
                    cursor: pointer;
                    margin-left: -10px;
                    display: flex;
                    padding: 5px 16px;
                    justify-content: center;
                    align-items: center;
                    min-width: 80px;
                    gap: 8px;
                    border-radius: var(--8, 8px);
                    // border: 1px solid #fff;
                    background:  #EEE;

                    color:  rgba(0, 0, 0, 0.90);
                    text-align: center;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 22px; /* 157.143% */
                }
                .navBottomLogin:hover{
                    background: #DCDCDC;
                }
                .navBottomLogin:active{
                    background: #EEE;
                }
                .navBottomReg{
                    cursor: pointer;
                    margin-left: -10px;
                    display: flex;
                    padding: 5px 16px;
                    // width: 80px;
                    justify-content: center;
                    align-items: center;
                    gap: 10px;
                    border-radius: var(--8, 8px);
                    background:  #212121;

                    color:  #FAFAFA;
                    text-align: center;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 22px; /* 157.143% */
                }
                .navBottomReg:hover{
                    background: #424242;
                }
                .navBottomReg:active{
                    background: #212121;
                }
                
            }
        }
    }
}
@media screen  and (max-width: 767px){
    .el-drawer__wrapper{
        top: 12vw !important;

    }
    .el-drawer.ttb{
        height: auto !important;
    }
    .headerRoot{
        .header{
            height: 12vw;
            padding:2vw 3.6vw;
            gap: 3vw;
            // border-bottom: 1px solid var(--Grey-Grey-200, #EEE);
            .headerLeft{
                gap:0.8vw;
                .mainTitle{
                    font-size: 3.6vw;
                }
                .subTitle{
                    font-size: 2vw;

                }
            }
            .headerRight{
                .navList{
                    gap: 3vw;
                    .noticeBox{
                        // position: relative;
                        // left: -30px;
                        .noticeIcon{
                            font-size: 5.4vw;
                        }
                        .noticeNum{
                            // position: absolute;
                            top: 0;
                            right: -1px;
                            transform: translateY(-50%) translateX(-10%);
                            background-color: red;
                            border-radius: 10px;
                            color: #fff;
                            display: inline-block;
                            font-size: 2.8vw;
                            height: 5vw;
                            line-height: 5vw;
                            text-align: center;
                            white-space: nowrap;
                            border: 1px solid #fff;
                        }
                    }
                    .navItem{
                        font-size: 2.6vw;
                    }
                    .navBottomLogin{
                        margin-left:-1vw;
                        padding:1.4vw 2.4vw;
                        min-width: 8vw;
                        gap: 0.8vw;
                        font-size: 3.4vw;
                        line-height:1.4;
                    }
                    .navBottomReg{
                        margin-left:-1vw;
                        padding:1.4vw 2vw;
                        gap: 0.8vw;
                        font-size:3.4vw;
                        line-height: 1.4;
                    }
                   
                }
                .menubtn{
                    margin-left:-1vw;
                    padding:calc(1.4vw - 1px)  2vw;
                    gap: 0.8vw;
                    font-size:3.4vw;
                    line-height: 1.4;
                    border:1px solid #FEAE00;
                    border-radius: 8px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    box-sizing: border-box;

                }
            }
        }
        .drawerBox{
            width: 100%;
            .stepItem{
                padding:3vw 8vw;
                gap:2vw;
                display: flex;
                flex-direction: column;
                border-bottom: 1px solid  #F5F5F5;
                background: var(--Grey-Grey-50, #FAFAFA);
                .titleItem{
                    color: #212121;
                    font-size: 4vw;
                    font-style: normal;
                    font-weight: 700;
                    line-height: normal;
                }
                .itemBox{
                    padding:0 4vw;
                    gap:2vw;
                    display: flex;
                    align-items: center;
                    border-radius: 10px;
                    .columItem{
                        color: #212121;
                        font-size: 3.4vw;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 2; 
                    }
                }
            }
        }
    }
}
@media screen  and (min-width: 767px) and (max-width: 1200px){
    .headerRoot{
        .header{
            padding:2vw 2.2vw;
            height: 9vw;
            gap: 3vw;
            .headerLogo{
                width: 5.5vw;
                height: 5.5vw;
                margin-right: -2.2vw;
            }
            .headerLeft{
                gap:0.2vw;
                .mainTitle{
                    font-size: 2.4vw;
                }
                .subTitle{
                    font-size: 1.4vw;

                }
            }
            .headerRight{
                margin-left: -24px;
                .navList{
                    gap: 1.5vw;
                    .navItem{
                        font-size: 1.4vw;
                    }
                    .navBottomLogin{
                        margin-left:-1vw;
                        padding:0.5vw 1.6vw;
                        min-width: 8vw;
                        gap: 0.8vw;
                        font-size: 1.4vw;
                        line-height: 2.2vw;
                    }
                    .navBottomReg{
                        margin-left:-1vw;
                        padding:0.5vw 1.6vw;
                        gap: 0.8vw;
                        font-size: 1.4vw;
                        line-height: 2.2vw;
                    }
                }
            }
        }
    }
}
</style>